module.exports = __webpack_public_path__ + "img/BANNER_DASH_GREENN2.ce9a6f3a.png";